import { DeviceMenuLocation } from "@package/ui-gql/index-data-access";
import { useSelectorWall } from "@package/ui-redux";
import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { useWallConfig } from "../../context/context-wall-config/context-wall-config";
import { useWallProvider } from "../../context/context-wall/context-wall";

type ScreenMenuOpenButtonProps = {
  screen: SliceWallScreenState;
};

const classLocationByDeviceMenuLocation: {
  [key in DeviceMenuLocation]: string;
} = {
  [DeviceMenuLocation.None]: "hidden",
  [DeviceMenuLocation.Topleft]: "top-0 left-0",
  [DeviceMenuLocation.Topright]: "top-0 right-0",
  [DeviceMenuLocation.Bottomleft]: "bottom-0 left-0",
  [DeviceMenuLocation.Bottomright]: "bottom-0 right-0",
};

export function ScreenMenuOpenButton({ screen }: ScreenMenuOpenButtonProps) {
  const { enabled: wallAppProvided } = useWallConfig();
  const provider = useWallProvider();
  const screenMenuLocation = useSelectorWall(
    (state) => state.wall.screenMenuLocation,
  );

  if (
    wallAppProvided &&
    screenMenuLocation &&
    screenMenuLocation !== DeviceMenuLocation.None &&
    !screen.menu &&
    !screen.flyout?.post
  ) {
    return (
      <div
        className={`absolute w-16 h-16 ${classLocationByDeviceMenuLocation[screenMenuLocation]}`}
        onPointerDown={() => provider?.onScreenMenuOpened(screen.id)}
      />
    );
  }

  return null;
}
